import React, { useState } from 'react';

const ITEMS_PER_PAGE = 12;

const CardGrid = ({ data, isPdfMode, basePath = '' , kategori = ''}) => {
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const filtered = data.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);

  const paginatedItems = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  return (
    <section className="p-6 md:p-12 bg-white">
      {/* Arama */}
      <div className="max-w-xl mx-auto mb-10">
        <input
          type="text"
          placeholder="Ara..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1); // arama yapılınca 1. sayfaya dön
          }}
          className="w-full border border-gray-300 rounded-lg px-5 py-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#a03838]"
        />
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8">
        {paginatedItems.map((item, index) => (
          <a
            key={index}
            href={
              isPdfMode
                ? item.link
                : `${basePath}/${kategori}/${item.id}`
            }
            target={isPdfMode ? '_blank' : '_self'}
            rel="noopener noreferrer"
            className="bg-[#a03838] border rounded-xl shadow hover:shadow-lg transition duration-300 group flex flex-col hover:scale-105 transform"
          >
            <div className="bg-gray-100 flex items-center justify-center h-48 rounded-t-xl overflow-hidden">
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-full object-cover"
            />
          </div>
            <div className="p-4 mt-auto text-center">
              <h3 className="text-sm font-semibold text-white group-hover:underline leading-snug">
                {item.title}
              </h3>
            </div>
          </a>
        ))}
      </div>

      {/* Sayfalama */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-10">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => setCurrentPage(index + 1)}
              className={`px-4 py-2 rounded-md border text-sm ${
                currentPage === index + 1
                  ? 'bg-[#a03838] text-white'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
              }`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default CardGrid;
